import { InjectionToken } from '@angular/core';

export const LOGIN_ROUTE_PATHNAME_TOKEN = new InjectionToken('login_page_url_token');
